module.exports = __webpack_public_path__ + "static/media/character_male.8c1b5de0.png";